import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';

import searchIcon from 'images/search_icon.svg';

import styles from './styles.module.css';

export default function SearchBar({
  placeholder,
  inDarkMode = false,
}: {
  placeholder: string;
  inDarkMode?: boolean;
}) {
  const [query, setQuery] = useState('');
  const [showSearchBar, setShowSearchBar] = useState(false);
  const inputRef = useRef<HTMLInputElement>();

  const handleChange = (e) => setQuery(e.target.value);

  const toggleSearch = () => {
    setShowSearchBar((prevState) => !prevState);
  };

  useEffect(() => {
    if (showSearchBar) {
      inputRef.current && inputRef.current.focus();
    }
  }, [showSearchBar]);

  return (
    <div className={styles.searchBar}>
      <form
        id="form_id"
        action="/search"
        method="get"
        className={styles.searchForm}
        data-id="search-form"
      >
        <div className={styles.searchInputContainer}>
          <img
            src={searchIcon}
            width="15"
            onClick={toggleSearch}
            className={styles.searchInputIcon}
          />
          <input
            type="text"
            name="query"
            className={clsx(styles.searchInput, {
              [styles.darkModeInput]: inDarkMode,
            })}
            placeholder={placeholder}
            value={query}
            onChange={handleChange}
            ref={inputRef}
          />
        </div>
        <input type="submit" className={styles.searchAction} value="Search" />
      </form>
    </div>
  );
}
